export type BlockedTableKey = 'description' | 'value';

export type BlockedTableItem = Record<BlockedTableKey, string>;

export type BlockedTableWidthCols = Record<BlockedTableKey, number>;

export const emptyListProps = {
  title: 'Não existem saldos bloqueados',
  description: 'Este cliente não possui saldo bloqueado no momento.',
};

export const tableHead: BlockedTableItem = {
  description: 'Descrição',
  value: 'Valor(R$)',
};

export const desktopWidthCols: BlockedTableWidthCols = {
  description: 80,
  value: 20,
};

export const tabletWidthCols: BlockedTableWidthCols = {
  description: 75,
  value: 15,
};

export const desktopMaxHeight = 550;
